

















import { ProjectProperty } from "@/api/project-api";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  model: { prop: "defaultValues" }
})
export default class ProjectPropertiesForm extends Vue {
  @Prop({ required: true }) defaultValues!: ProjectProperty[];

  values: ProjectProperty[] = [];

  get availableValues(): ProjectProperty[] {
    return this.values.filter(p => !p.key.deletedAt);
  }

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(defaultValues: ProjectProperty[]) {
    this.values = defaultValues;
  }
}
